import React from 'react';
import { C, Card } from '../components/UI';
import { EstimateRequestForm } from '../components/EstimateRequestForm';
import { useBranding } from '../context/BrandingContext';
import { useFeature } from '../context/FeatureFlagContext';
import { api } from '../services/api';

// Public, no login required. Reachable at /request-estimate. Works whether or not the visitor
// happens to have a JWT (a logged-in customer opening this link still submits anonymously here —
// the in-app "Request an Estimate" tile on the Services page is the authenticated path, which
// auto-links the request to their account instead). Same guest-capable header pattern as
// PreorderPage.tsx. Gated on the estimateBuilder flag same as the backend endpoint and the
// in-app tile — a tenant with it off shouldn't see a working-looking form that 403s on submit.

export default function RequestEstimatePage() {
    const branding = useBranding();
    const estimateBuilderEnabled = useFeature('estimateBuilder');

    return (
        <div style={{ minHeight: '100vh', background: C.bg, fontFamily: "'Inter', sans-serif", color: C.text }}>
            <div style={{ background: branding.primaryColor, padding: '0 24px', display: 'flex', alignItems: 'center', gap: 16, height: 56 }}>
                {branding.logoUrl
                    ? <img src={branding.logoUrl} alt={branding.appName} style={{ height: 32, maxWidth: 120, objectFit: 'contain' }} />
                    : <span style={{ fontSize: 18, fontWeight: 700, color: branding.navTextColor ?? '#fff', letterSpacing: -0.5 }}>{branding.appName}</span>
                }
                <span style={{ color: branding.navTextColor ?? '#fff', fontSize: 13, opacity: 0.7 }}>· Request an Estimate</span>
            </div>

            <div style={{ maxWidth: 480, margin: '0 auto', padding: '32px 20px' }}>
                {estimateBuilderEnabled ? (
                    <Card>
                        <h1 style={{ margin: '0 0 4px', fontSize: 20 }}>📋 Request an Estimate</h1>
                        <p style={{ margin: '0 0 20px', fontSize: 13, color: C.textSub }}>
                            Tell us about the job and attach a few photos — we'll review it and follow up with a real quote.
                        </p>
                        <EstimateRequestForm onSubmit={async body => { await api.requestEstimatePublic(body); }} />
                    </Card>
                ) : (
                    <Card style={{ textAlign: 'center', padding: 40 }}>
                        <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
                        <div style={{ fontWeight: 600, marginBottom: 4 }}>Estimate requests aren't available right now</div>
                        <div style={{ fontSize: 13, color: C.textSub }}>Please check back later, or contact us directly.</div>
                    </Card>
                )}
            </div>
        </div>
    );
}
